export const circles = [
  { id: 1, color: "#F5D3B9" },
  { id: 2, color: "#D8B191" },
  { id: 3, color: "#E1C2B0" },
  { id: 4, color: "#F3CB9C" },
  { id: 5, color: "#C2C0AA" },
  { id: 6, color: "#E7E5DA" },
  { id: 7, color: "#F2EAD6" },
  { id: 8, color: "#FCDFD6" },
];
